import { LocalizedElement } from '../i18n/Language';
import WhatsAppIcon from './WhatsAppIcon';
import React from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../mockData';
import { trackEvent } from '../lib/analytics';

const StickyActions = () => {
  const pageUrl = () => typeof window !== 'undefined' ? window.location.href : '';
  return (
    <>
      {/* Sticky Call Button */}
      <LocalizedElement as="a"
      href={`tel:+91${businessInfo.phone1}`}
      onClick={() => trackEvent('call_click', { location: 'sticky', page_url: pageUrl() })}
      className="fixed bottom-6 left-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all hover:scale-110 z-40 group"
      aria-label={`Call ${businessInfo.phone1}`}
      data-testid="sticky-call-btn">

        <Phone size={24} className="animate-pulse" />
        <LocalizedElement as="span" className="absolute left-full ml-3 bg-gray-900 text-white px-3 py-1 rounded text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          Call Now
        </LocalizedElement>
      </LocalizedElement>

      {/* Sticky WhatsApp Button */}
      <LocalizedElement as="a"
      href={`https://wa.me/91${businessInfo.whatsapp}?text=${encodeURIComponent('Hi, I want to book a taxi')}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('whatsapp_click', { location: 'sticky', page_url: pageUrl() })}
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#1ebe5d] transition-all hover:scale-110 z-40 group"
      aria-label={`WhatsApp ${businessInfo.whatsapp}`}
      data-testid="sticky-whatsapp-btn">

        <WhatsAppIcon size={24} />
        <LocalizedElement as="span" className="absolute right-full mr-3 bg-gray-900 text-white px-3 py-1 rounded text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          WhatsApp
        </LocalizedElement>
      </LocalizedElement>
    </>);

};

export default StickyActions;
